import { Builder } from '@builder.io/sdk';
import IconCardsCarousel from './IconCardsCarousel';
import { IconNames, FillColours } from '../Icon/Icon';

const IconCardsCarouselConfig = {
  name: 'IconCardsCarousel',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      defaultValue: 'Enter a heading...',
    },
    {
      name: 'items',
      type: 'list',
      subFields: [
        {
          name: 'icon',
          type: 'enum',
          defaultValue: IconNames[0],
          enum: IconNames.map((n) => ({
            label: n,
            value: n,
          })),
        },
        {
          name: 'fillColour',
          type: 'enum',
          defaultValue: FillColours[0],
          enum: FillColours.map((n) => ({
            label: n,
            value: n,
          })),
        },
        {
          name: 'title',
          type: 'string',
        },
        {
          name: 'contents',
          type: 'richText',
          defaultValue: '<p>Enter the content here....</p>',
        },
      ],
    },
  ],
};

Builder.registerComponent(IconCardsCarousel, IconCardsCarouselConfig);
